import { Translate } from 'react-redux-i18n'
import TooltipExpression from '../../common/tooltipExpression'

export const TREND_DATA = [
  { value: 'IS3', color: '#006AA6', isBarChart: true },
  { value: 'BS64', color: '#FFCD60', isBarChart: true },
  {
    value: 'FA073',
    color: '#4EB1CB',
    isLineChart: true,
    tooltipContent: (
      <TooltipExpression
        expressions={[
          {
            text: <Translate value="financialAnalysis.MARKET_SHARE_1" />,
            operator: '=',
          },
          {
            text: <Translate value="financialAnalysis.MARKET_SHARE_2" />,
            isDivide: true,
            textUnder: <Translate value="financialAnalysis.MARKET_SHARE_3" />,
          },
        ]}
      />
    ),
  },
  {
    value: 'FA074',
    color: '#F49966',
    isLineChart: true,
    tooltipContent: (
      <TooltipExpression
        expressions={[
          {
            text: <Translate value="financialAnalysis.OTHER_MARKET_SHARE_1" />,
            operator: '=',
          },
          {
            text: <Translate value="financialAnalysis.OTHER_MARKET_SHARE_2" />,
            isDivide: true,
            textUnder: (
              <Translate value="financialAnalysis.OTHER_MARKET_SHARE_3" />
            ),
          },
        ]}
      />
    ),
  },
]

export const PERCENTAGE_KEYS = ['FA073', 'FA074']
export const EXCEPT_KEYS = ['year']
